import { Markdown } from '@components/Markdown';
import type { UIMessage } from 'ai';
import { Bot, User } from 'lucide-react';
import React from 'react';

import { ChatToolInvocation } from './ChatToolInvocation';

interface ChatMessageBubbleProps {
  message: UIMessage;
}

export function ChatMessageBubble({ message }: ChatMessageBubbleProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex gap-3 ${isUser ? 'flex-row-reverse' : ''}`}>
      <div
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
          isUser ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
        }`}
      >
        {isUser ? <User className="h-4 w-4" /> : <Bot className="h-4 w-4" />}
      </div>
      <div className={`max-w-[85%] space-y-2 ${isUser ? 'text-right' : ''}`}>
        {message.parts.map((part, i) => {
          if (part.type === 'text') {
            return (
              <div
                key={i}
                className={`rounded-lg px-4 py-3 text-sm ${
                  isUser
                    ? 'inline-block bg-primary text-primary-foreground'
                    : 'bg-muted text-foreground'
                }`}
              >
                <Markdown>{part.text}</Markdown>
              </div>
            );
          }
          if (part.type === 'dynamic-tool') {
            return (
              <ChatToolInvocation
                key={i}
                toolName={part.toolName}
                state={part.state}
                result={part.state === 'output-available' ? part.output : undefined}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
